import { render } from "./EditEmployeeLayout.vue?vue&type=template&id=0349f171&scoped=true"
import script from "./EditEmployeeLayout.vue?vue&type=script&lang=js"
export * from "./EditEmployeeLayout.vue?vue&type=script&lang=js"

import "./EditEmployeeLayout.vue?vue&type=style&index=0&id=0349f171&lang=scss&scoped=true"

import exportComponent from "/opt/karibu-hrms/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0349f171"]])

export default __exports__